import React from 'react';
import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { snakeize } from '../object';
import { PACKAGE_NAME } from './constants';

/**
 * Logs a contextualized warning.
 *
 * @param {Object} config
 * @param {Error} config.error - The thrown error.
 * @param {string} config.description - The warning description.
 * @param {Object} [params] - Additional params to be logged with the warning message.
 */
export const logWarning = ({ error, description, ...params }) => {
    const { userId, url } = getContext();
    const enrichmentParams = snakeize({
        userId,
        url,
        description,
        originPackage: PACKAGE_NAME,
        ...params
    });

    logger.warn(error, enrichmentParams);
};
